import React from 'react';

import { AnswerFAQProps } from '@/types/props';

const Answer: React.FC<AnswerFAQProps & { index: number }> = ({
  answer,
  isActive,
}) => {
  return (
    <div
      className={`grid transition-all duration-300 ease-in-out ${
        isActive ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
      }`}
    >
      <div className='overflow-hidden'>
        <div className='border-t border-greenSecondary/10 bg-gradient-to-b from-greenSecondary/[0.04] to-transparent px-4 pb-5 pt-4 sm:px-5 sm:pb-6 sm:pl-[5.75rem]'>
          <p className='text-sm leading-relaxed text-graySecondary sm:text-[15px] sm:leading-7'>
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Answer;
